import type {Action} from '../bootstrap';
/**
 * @param exports module.exports
 * @param actions Actions
 * @return Extended actions
 *
 * @deprecated For old backbone actions
 */
export const extendBackboneActions = (exports: Action[], actions: Action[]) => {
	actions.forEach((action) => {
		const existing = exports.find((exp) => exp.event === action.event);
		if (!existing) return;
		Object.assign(existing, action);
	});
	return exports;
};

export default extendBackboneActions;
